export default __webpack_public_path__ + "static/media/Aspirant.c921a39c.png";